import { axiosApi } from '@/api/axios';

export default {
  show(id = 1) { // for now, users do not have departments yet
    return axiosApi.get(`/helps/${id}`);
  },
  update(id = 1, params) { // for now, users do not have departments yet
    return axiosApi.patch(`/helps/${id}`, params);
  },
};
